import VerifyCodeByNewPhone from './VerifyCodeByNewPhone'

export default VerifyCodeByNewPhone
